import React from 'react';

import linkTextFramesOperation, {
  getLinkableTextFrames,
} from 'editor/src/store/design/operation/linkTextFramesOperation';
import isTextFlowAllowed from 'editor/src/store/editor/selector/isTextFlowAllowed';
import { useDispatch } from 'editor/src/store/hooks';

import useTr from 'editor/src/util/useTr';

import IconLinked from 'editor/src/component/Icon/IconLinked';
import { CanShow, MenuItemProps } from 'editor/src/component/Menu/type';
import MenuButton from 'editor/src/component/TopMenuDesktop/buttons/MenuButton';

// two or more texts on one spread that can take a fixed frame
export const canShow: CanShow = (state, { isSelectionLocked }) =>
  !isSelectionLocked && isTextFlowAllowed(state) && getLinkableTextFrames(state).length >= 2;

type Props = Pick<MenuItemProps, 'mode' | 'close'>;

function ButtonLinkTextFrames({ mode, close }: Props) {
  const dispatch = useDispatch();
  const tr = useTr();

  const handleClick = () => {
    dispatch(linkTextFramesOperation());
    close?.();
  };

  return (
    <MenuButton
      Icon={IconLinked}
      mode={mode}
      handleClick={handleClick}
      label={tr('editor-text-flow-link', 'Link frames')}
      className="cy-button-link-text-frames"
    />
  );
}

export default React.memo(ButtonLinkTextFrames);
